<template>
  <div class="role_dialog">
    <el-dialog
      :title="title"
      :before-close="cancelButton"
      :visible.sync="dialogVisible"
      max-width="70%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="Role list:" prop>
          <div class="permission">
            <el-tree
              :data="data"
              show-checkbox
              node-key="id"
              default-expand-all
              :props="defaultProps"
              ref="tree"
              :default-checked-keys="defaultArray"
            ></el-tree>
          </div>
        </el-form-item>
        <el-form-item class="button">
          <el-button type="primary" @click="submitForm('ruleForm')">Submit</el-button>
          <el-button @click="resetForm('ruleForm')">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { userRoleList } from "@/common/js/http/version3Api.js";

export default {
  props: [
    "passVisible",
    "title",
    "editMessage",
    "selectValue",
    "inputValue",
    "editId",
    "roleArray"
  ],
  name: "RoleDialog",
  data() {
    return {
      defaultArray: [],
      dialogVisible: false,
      id: "",
      repeatName: "",
      roleIds: [],
      idsArray: [],
      ruleForm: {
        roleName: "",
        roleDesc: "",
        status: "1"
      },
      rules: {
        //roleName: [{ required: true, validator: roleNameMessage, trigger: "blur"}],
        // roleDesc: [
        //   {
        //     required: true,
        //     message: "Please enter a roleDesc",
        //     trigger: "blur"
        //   }
        // ],
        status: [
          { required: true, message: "Please Role status", trigger: "change" }
        ]
      },
      data: [],
      defaultProps: {
        label: "roleName",
        id: "id"
      },
      repeatName: false
    };
  },
  created() {
    this.getRoleList();
  },
  methods: {
    cancelButton() {
      this.resetForm("ruleForm");
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.roleIds = this.$refs.tree.getCheckedKeys();
          this.$emit("submitFormRole", this.roleIds);
          this.resetForm("ruleForm");
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.$emit("visible", false);
      this.$refs.tree.setCheckedKeys([]);
    },
    //获取角色列表的树
    getRoleList() {
      let data = {
        pageSize: 100
      };
      userRoleList().then(res => {
        this.data = res.result;
      });
    }
  },
  watch: {
    passVisible(val) {
      this.dialogVisible = val;
    },
    editId() {
      this.id = this.editId;
    },
    roleArray: {
      handler(val) {
        this.defaultArray = val;
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.role_dialog >>> .el-form-item__content .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.role_dialog >>> .button .el-form-item__content button {
  height: 32px;
  line-height: 32px;
  padding: 0 20px;
}
.role_dialog >>> .el-form-item__content {
  margin-left: 120px !important;
}
.role_dialog >>> .el-form-item__label {
  width: 120px !important;
}
.role_dialog >>> .button {
  text-align: right;
  margin-bottom: 0;
}
.role_dialog >>> .el-dialog__body {
  padding-top: 10px;
}
.permission {
  height: 300px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow-y: scroll;
}
</style>